import { render, staticRenderFns } from "./slider-default.mpx?vue&type=template&id=77d4ba4c&isComponent&outputPath=components%2Fslider-default1491d0a4%2Findex"
import script from "./slider-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-default1491d0a4%2Findex"
export * from "./slider-default.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-default1491d0a4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports